import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { BaseRestService } from './base-rest.service';
import { IRetentionList, Retention } from '../models/retention';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Subject } from '../models/subject';

@Injectable({
  providedIn: 'root',
})
export class RetentionService
  extends BaseRestService<Retention, IRetentionList>
  implements OnDestroy {
    
  listOfRetentions: Retention[]= [];

  constructor(http: HttpClient, protected router: Router) {
    super(RetentionService, http, 'api/retentions', 'retention', router);

    // enable caching
    this.cacheEnabled = true;    
    
    this.onChanged.subscribe((retentions) => {
      this.listOfRetentions = [...retentions]
      .filter((i) => !i.hideRecord)
      .sort((a, b) => a.name.localeCompare(b.name));
    });
  }
  
  ngOnDestroy(): void {
  }

  public ApplyRetentionToSubject(retention: Retention, subject: Subject): Subject {
    if (!retention)
      return null;
    if (!subject)
      return null;

    // Update Subject with new Retention date and Retention Id
    var daysToAdd = retention.retentionDays;
    let retentionDate = '';

    var oldRetentionId = subject.retentionId;
    var oldRetentionDays = this.listOfRetentions.filter(
      (i) => i.id === oldRetentionId
    )[0]?.retentionDays;

    if (oldRetentionDays && oldRetentionId) {
      daysToAdd = daysToAdd - oldRetentionDays;
      retentionDate = this.convertToRetentionDays(
        subject,
        daysToAdd,
        subject.retentionDate
      );
    } else {
      retentionDate = this.convertToRetentionDays(subject, daysToAdd, null);
    }
    subject.retentionDate = retentionDate;
    subject.retentionId = retention.id;

    return subject;
  }

  convertToRetentionDays(targetSubject: Subject, daysToAdd: number, oldDate) {
    let newDate;
    let subject = new Subject(targetSubject); // this.data.subject);
    var dateClosed = subject.getDataFieldValue('dateclosed');

    // If no date closed and subject archived then use todays date.
    if ((!dateClosed || dateClosed == null) && subject.archived == true) {
      dateClosed = new Date();
    }

    if (oldDate) {
      newDate = new Date(oldDate);
      // Add the number of days to the milliseconds since epoch
    } else {
      newDate = new Date(dateClosed);
    }
    newDate.setDate(newDate.getDate() + daysToAdd);

    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = String(newDate.getDate()).padStart(2, '0');
    const monthIndex = newDate.getMonth();
    const month = monthNames[monthIndex];
    const year = newDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

}
